import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  DialogContent,
  DialogContentText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  styled
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUpdateSingleAccount } from '../helper/getUpdateSingleAccount';
import { updateVendorAccountData } from 'app/contexts/reducers/account/accountSlice';
const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));
const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main }
}));
export default function UpdateVendorAccountDialog({
  open,
  onClose,
  updateAccountId,
  setApiCall,
  handleClickSuccess,
  setError,
  handleClickError
}) {
  const dispatch = useDispatch();
  const { vendorData, accountType } = useSelector((state) => state.account);
  const { isVendorSuccess } = useSelector((state) => state.account);
  const [updateValue, setUpdateValue] = useState({
    vendorType: 'RETAILER',
    accountName: '',
    openingBalance: '',
    reference: '',
    specialNote: '',
    firstName: '',
    lastName: '',
    firmName: '',
    address: '',
    mobileNumber: '',
    email: ''
  });
  const [accountNameError, setAccountNameError] = useState(false);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (vendorData) {
      getUpdateSingleAccount(vendorData.data.data, updateAccountId).then((data) => {
        data &&
          setUpdateValue({
            vendorType: data.vendor_type,
            accountName: data.account_name,
            openingBalance: data.opening_balance,
            reference: data.reference,
            specialNote: data.special_note,
            firstName: data.first_name,
            lastName: data.last_name,
            firmName: data.firm_name,
            address: data.address,
            mobileNumber: data.mobile_number,
            email: data.email
          });
      });
    }
  }, [updateAccountId, isVendorSuccess, vendorData]);

  async function handleUpdate() {
    try {
      setLoading(true);
      const currentAccount = await getUpdateSingleAccount(vendorData.data.data, updateAccountId);
      if (accountType.toLowerCase() === 'vendor') {
        if (updateValue.accountName !== currentAccount.account_name) {
          const updateVendorData = { ...updateValue };
          Object.keys(updateVendorData).forEach((key) => {
            if (updateVendorData[key] === '') {
              delete updateVendorData[key];
            }
          });
          const response = await dispatch(
            updateVendorAccountData({ updateAccountId, updateVendorData })
          );
          if (!response.hasOwnProperty('error')) {
            onClose();
            setApiCall((prev) => !prev);
            handleClickSuccess('Account Update successfully');
            setLoading(false);
          } else {
            throw response;
          }
        } else {
          if (updateValue.vendorType.length > 0) {
            const updateVendorData = { ...updateValue };
            Object.keys(updateVendorData).forEach((key) => {
              if (
                key === 'accountName' ||
                updateVendorData[key] === '' ||
                updateVendorData[key] === null
              ) {
                delete updateVendorData[key];
              }
            });
            const response = await dispatch(
              updateVendorAccountData({ updateAccountId, updateVendorData })
            );
            if (!response.hasOwnProperty('error')) {
              onClose();
              setApiCall((prev) => !prev);
              handleClickSuccess('Account Update successfully');
              setLoading(false);
            } else {
              throw response;
            }
          } else {
            onClose();
            setLoading(false);
          }
        }
      }
    } catch (e) {
      handleClickError();
      setError(e);
      setLoading(false);
    }
  }

  return (
    <Box>
      <Dialog open={open} onClose={onClose} aria-labelledby='form-dialog-title'>
        <DialogTitle id='form-dialog-title'>Update Vendor</DialogTitle>
        <DialogContent>
          <DialogContentText>You can Update Your Vendor Details From Here!</DialogContentText>

          <Grid container spacing={3} sx={{ mb: '24px' }}>
            <Grid item xs={12} md={12}>
              <StyledCard elevation={6}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <InputLabel id='vendorType' sx={{ fontSize: '11px' }}>
                      Vendor Type
                    </InputLabel>
                    <Select
                      size='small'
                      sx={{ width: '95%', my: 1 }}
                      variant='standard'
                      labelId='vendorType'
                      onChange={(e) => {
                        setUpdateValue({ ...updateValue, vendorType: e.target.value });
                      }}
                      value={updateValue.vendorType}
                    >
                      <MenuItem value='FIRM' id={1}>
                        FIRM
                      </MenuItem>
                      <MenuItem value='RETAILER' id={2}>
                        RETAILER
                      </MenuItem>
                    </Select>
                    <ContentBox>
                      <TextField
                        error={accountNameError}
                        id='accountName'
                        type='text'
                        size='small'
                        margin='dense'
                        label='Account Name'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        required
                        helperText={accountNameError ? 'Please Enter Account Name' : ''}
                        value={updateValue.accountName}
                        onChange={(e) => {
                          setAccountNameError(false);
                          setUpdateValue({ ...updateValue, accountName: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='openingBalance'
                        type='number'
                        size='small'
                        margin='dense'
                        label='Opening Balance'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.openingBalance == null ? '' : updateValue.openingBalance}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, openingBalance: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='email'
                        type='email'
                        margin='dense'
                        size='small'
                        label='Email'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.email == null ? '' : updateValue.email}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, email: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='reference'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Reference'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.reference == null ? '' : updateValue.reference}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, reference: e.target.value });
                        }}
                      />
                    </ContentBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <ContentBox>
                      <TextField
                        id='firmName'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Firm Name'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.firmName == null ? '' : updateValue.firmName}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, firmName: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='firstName'
                        type='text'
                        margin='dense'
                        size='small'
                        label='First Name'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.firstName == null ? '' : updateValue.firstName}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, firstName: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='lastName'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Last Name'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.lastName == null ? '' : updateValue.lastName}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, lastName: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='address'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Address'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.address == null ? '' : updateValue.address}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, address: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <ContentBox>
                      <TextField
                        id='contactNumber'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Contact Number'
                        sx={{ my: 1, width: '95%' }}
                        variant='standard'
                        value={updateValue.mobileNumber == null ? '' : updateValue.mobileNumber}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, mobileNumber: e.target.value });
                        }}
                      />
                    </ContentBox>
                  </Grid>
                </Grid>

                <TextField
                  rows={6}
                  id='specialNote'
                  type='text'
                  margin='dense'
                  size='small'
                  label='Special Note'
                  sx={{ my: 1, width: '95%' }}
                  variant='standard'
                  multiline
                  maxRows={4}
                  value={updateValue.specialNote == null ? '' : updateValue.specialNote}
                  onChange={(e) => {
                    setUpdateValue({ ...updateValue, specialNote: e.target.value });
                  }}
                />
              </StyledCard>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='standard' color='secondary' onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            onClick={handleUpdate}
            color='primary'
            loading={loading}
            variant='contained'
            sx={{ my: 2 }}
          >
            Update Item
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
